
 
  /* 本文件未 autoview.js 自动生成  执行 npm run dir*/
	export default [

{
          path: '/bill/comfirm',
          name: 'billComfirm', 
          component: () => import('@/view/bill/comfirm.vue'),
        },
{
          path: '/bill/detail',
          name: 'billDetail', 
          component: () => import('@/view/bill/detail.vue'),
        },
{
          path: '/bill/pay',
          name: 'billPay', 
          component: () => import('@/view/bill/pay.vue'),
        },
{
          path: '/bill/payment',
          name: 'billPayment', 
          component: () => import('@/view/bill/payment.vue'),
        },
{
          path: '/bill/record',
          name: 'billRecord', 
          component: () => import('@/view/bill/record.vue'),
        },
{
          path: '/bill/recordDetail',
          name: 'billRecorddetail', 
          component: () => import('@/view/bill/recordDetail.vue'),
        },
{
          path: '/bill/repay',
          name: 'billRepay', 
          component: () => import('@/view/bill/repay.vue'),
        },
{
          path: '/bill/repayDetail',
          name: 'billRepaydetail', 
          component: () => import('@/view/bill/repayDetail.vue'),
        },
{
          path: '/certificate/comfirm',
          name: 'certificateComfirm', 
          component: () => import('@/view/certificate/comfirm.vue'),
        },
{
          path: '/certificate/detail',
          name: 'certificateDetail', 
          component: () => import('@/view/certificate/detail.vue'),
        },
{
          path: '/certificate/list',
          name: 'certificateList', 
          component: () => import('@/view/certificate/list.vue'),
        },
{
          path: '/certificate/record',
          name: 'certificateRecord', 
          component: () => import('@/view/certificate/record.vue'),
        },
{
          path: '/certificate/recordDetail',
          name: 'certificateRecorddetail', 
          component: () => import('@/view/certificate/recordDetail.vue'),
        },
{
          path: '/enterprise/detail',
          name: 'enterpriseDetail', 
          component: () => import('@/view/enterprise/detail.vue'),
        },
{
          path: '/enterprise/list',
          name: 'enterpriseList', 
          component: () => import('@/view/enterprise/list.vue'),
        },
{
          path: '/enterpriseCorrelation/detail',
          name: 'enterpriseCorrelationDetail', 
          component: () => import('@/view/enterpriseCorrelation/detail.vue'),
        },
{
          path: '/enterpriseCorrelation/list',
          name: 'enterpriseCorrelationList', 
          component: () => import('@/view/enterpriseCorrelation/list.vue'),
        },
{
          path: '/finance/detail',
          name: 'financeDetail', 
          component: () => import('@/view/finance/detail.vue'),
        },
{
          path: '/finance/list',
          name: 'financeList', 
          component: () => import('@/view/finance/list.vue'),
        },
{
          path: '/financing/applyAmount',
          name: 'financingApplyamount', 
          component: () => import('@/view/financing/applyAmount.vue'),
        },
{
          path: '/financing/audit',
          name: 'financingAudit', 
          component: () => import('@/view/financing/audit.vue'),
        },
{
          path: '/financing/complete',
          name: 'financingComplete', 
          component: () => import('@/view/financing/complete.vue'),
        },
{
          path: '/financing/financingProtocol',
          name: 'financingFinancingprotocol', 
          component: () => import('@/view/financing/financingProtocol.vue'),
        },
{
          path: '/financing/index',
          name: 'financingIndex', 
          component: () => import('@/view/financing/index.vue'),
        },
{
          path: '/financing/institution',
          name: 'financingInstitution', 
          component: () => import('@/view/financing/institution.vue'),
        },
{
          path: '/financing/institutionComfirm',
          name: 'financingInstitutioncomfirm', 
          component: () => import('@/view/financing/institutionComfirm.vue'),
        },
{
          path: '/financing/selectBill',
          name: 'financingSelectbill', 
          component: () => import('@/view/financing/selectBill.vue'),
        },
{
          path: '/financing/turnProtocol',
          name: 'financingTurnprotocol', 
          component: () => import('@/view/financing/turnProtocol.vue'),
        },
{
          path: '/financingOrder/detail',
          name: 'financingOrderDetail', 
          component: () => import('@/view/financingOrder/detail.vue'),
        },
{
          path: '/financingOrder/list',
          name: 'financingOrderList', 
          component: () => import('@/view/financingOrder/list.vue'),
        },
{
          path: '/protocol/register',
          name: 'protocolRegister', 
          component: () => import('@/view/protocol/register.vue'),
        },
{
          path: '/protocol/user',
          name: 'protocolUser', 
          component: () => import('@/view/protocol/user.vue'),
        },
{
          path: '/sign/caSeal',
          name: 'signCaseal', 
          component: () => import('@/view/sign/caSeal.vue'),
        },
{
          path: '/sign/offlineSeal',
          name: 'signOfflineseal', 
          component: () => import('@/view/sign/offlineSeal.vue'),
        },
{
          path: '/sign/selectSign',
          name: 'signSelectsign', 
          component: () => import('@/view/sign/selectSign.vue'),
        },
{
          path: '/sign/webSeal',
          name: 'signWebseal', 
          component: () => import('@/view/sign/webSeal.vue'),
        },
{
          path: '/user/account/info',
          name: 'userAccountInfo', 
          component: () => import('@/view/user/account/info.vue'),
        },
{
          path: '/user/account/modifyPasw',
          name: 'userAccountModifypasw', 
          component: () => import('@/view/user/account/modifyPasw.vue'),
        },
{
          path: '/user/ca',
          name: 'userCa', 
          component: () => import('@/view/user/ca.vue'),
        },
{
          path: '/user/company/edit',
          name: 'userCompanyEdit', 
          component: () => import('@/view/user/company/edit.vue'),
        },
{
          path: '/user/company/info',
          name: 'userCompanyInfo', 
          component: () => import('@/view/user/company/info.vue'),
        },
]